import { createSubtitlesCustomMenu } from './create-subtitles-custom-menu'
import { getFontSizeMenuItems } from './lib'

/**
 * Settings subtitles font size menu
 */
export const SettingsSubtitlesFontSizeMenu = createSubtitlesCustomMenu(
  'SettingsSubtitlesFontSizeMenu',
  'font_size',
  getFontSizeMenuItems
)
